var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCloudRain = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 10.8333V17.5M6.66637 10.8333V17.5M9.9997 12.5V19.1667M16.6664 13.8167C17.5424 13.433 18.2598 12.7596 18.6981 11.9096C19.1364 11.0596 19.269 10.0847 19.0735 9.14847C18.8781 8.21228 18.3665 7.37183 17.6247 6.76818C16.8829 6.16453 15.9561 5.83444 14.9997 5.83332H13.9497C13.6855 4.81042 13.1821 3.86494 12.4808 3.07482C11.7795 2.28469 10.9005 1.67255 9.91617 1.28884C8.93187 0.905124 7.87046 0.760832 6.81944 0.867855C5.76842 0.974877 4.75788 1.33015 3.87111 1.90439C2.98435 2.47863 2.24675 3.25539 1.71912 4.17065C1.19149 5.08591 0.888929 6.11346 0.836379 7.16861C0.783828 8.22376 0.982793 9.27629 1.41687 10.2394C1.85095 11.2026 2.50772 12.0488 3.33304 12.7083",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloudRain, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cloud-rain.a8f07c9c.svg";
export { ForwardRef as ReactComponent };